import { Field, useField, useFormikContext } from 'formik';
import { memo } from 'react';

import { useOptionContext } from '@/resources/hooks/useOptionsContext';

import { ICartItemValues } from '../../../../../store/ducks/order/types';
import OptionPrice from '../OptionPrice';

function Checkbox() {
  const { answer, optionIndex, selectOptionIndex, maxOfAnswers } = useOptionContext();
  const { values } = useFormikContext<ICartItemValues>();
  const selectOptionInForm = values.options[optionIndex]?.select_options[selectOptionIndex];
  const quantity = parseInt(selectOptionInForm?.quantity ?? '0');

  const [field, , { setValue }] = useField({
    type: 'checkbox',
    value: answer.id.toString(),
    name: `options.${optionIndex}.select_options.id`,
  });

  const onChange = () => {
    setValue(answer.id.toString());

    if (selectOptionInForm) {
      selectOptionInForm.chosen = !selectOptionInForm.chosen;
    }
  };

  const isChecked = () => selectOptionInForm && selectOptionInForm.chosen;

  const validateMaxOfAnswers = () => {
    let answers = 0;

    values.options[optionIndex]?.select_options.forEach((answer) => {
      if (answer.chosen) answers += 1;
    });

    return maxOfAnswers <= answers && !isChecked();
  };

  const isDisabled = validateMaxOfAnswers();

  return (
    <div className="d-flex align-items-center justify-content-between my-2">
      <div className="d-flex align-items-center flex-row">
        <Field
          type="hidden"
          name={`options.${optionIndex}.select_options.${selectOptionIndex}.id`}
          value={answer.id.toString()}
        />

        <label
          htmlFor={`checkbox-${optionIndex}-${selectOptionIndex}`}
          className="mb-0 user-select-none"
          style={{
            color: isDisabled ? '#9b9b9b' : '#212529',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          <Field
            {...field}
            type="checkbox"
            onChange={onChange}
            checked={isChecked()}
            disabled={isDisabled}
            id={`checkbox-${optionIndex}-${selectOptionIndex}`}
          />
          <span className="ml-1 answer-title">{answer.title}</span>
        </label>
      </div>

      <div>
        <OptionPrice quantity={quantity} showSubtotal={false} />
      </div>
    </div>
  );
}

export default memo(Checkbox);
